/**
 * Pure marketing-path helpers safe for Vercel Node serverless (no browser Supabase).
 * Browser/runtime helpers live in `saasMarketingPaths.ts`.
 */

export type SaasMarketingPathKey = 'cleaningChemicals' | 'insurance' | 'addonServices' | 'aiChat' | 'bookNow';

export type SaasMarketingPathConfig = Partial<Record<SaasMarketingPathKey, string>>;

export const DEFAULT_SAAS_MARKETING_PATHS: Record<SaasMarketingPathKey, string> = {
  cleaningChemicals: '/cleaning-chemicals',
  insurance: '/insurance',
  addonServices: '/addon-services',
  aiChat: '/ai-chat',
  bookNow: '/book-now',
};

const PATH_KEYS: SaasMarketingPathKey[] = [
  'cleaningChemicals',
  'insurance',
  'addonServices',
  'aiChat',
  'bookNow',
];

export function parseSaasMarketingPathConfig(raw: unknown): SaasMarketingPathConfig {
  if (!raw || typeof raw !== 'object') return {};
  const src = raw as Record<string, unknown>;
  const out: SaasMarketingPathConfig = {};
  for (const key of PATH_KEYS) {
    const value = src[key];
    if (typeof value === 'string' && value.trim()) {
      out[key] = value.trim().slice(0, 200);
    }
  }
  return out;
}

export function mergeSaasMarketingPathConfig(
  platformDefaults: SaasMarketingPathConfig = {},
  orgOverride?: SaasMarketingPathConfig | null,
): Record<SaasMarketingPathKey, string> {
  return {
    ...DEFAULT_SAAS_MARKETING_PATHS,
    ...platformDefaults,
    ...(orgOverride ?? {}),
  };
}

export function parseOrgMarketingPathsFromBranding(
  branding?: Record<string, unknown> | null,
): SaasMarketingPathConfig {
  if (!branding || typeof branding !== 'object') return {};
  const nested = branding.marketingPaths;
  if (nested && typeof nested === 'object') {
    return parseSaasMarketingPathConfig(nested);
  }
  return parseSaasMarketingPathConfig(branding);
}
